package analytics

import org.koin.core.module.Module
import org.koin.dsl.module

fun analyticsModule(config: AnalyticsConfig): Module = module {
    includes(analyticsPlatformModule())
    single { config }
    single<Analytics> {
        val resolved = get<AnalyticsConfig>()
        val logger = resolved.logger
        when {
            !resolved.enabled || resolved.apiKey.isBlank() -> {
                if (resolved.debug) LoggingAnalytics(logger) else NoOpAnalytics
            }
            else -> PostHogAnalytics(
                config = resolved,
                preferences = get(),
                http = get(),
                logger = logger,
            )
        }
    }
}
